export default {
  table_ordering: 'Table ordering',
  table: 'Table',
  pickup_or_delivery: 'Pickup or delivery',
  asap: 'As soon as possible',
  served_in: 'Served in {{time}} min',
  not_taking_orders: 'Not taking orders',
  not_your_table: 'Not your table? Scan the code on yours.',
  eating_here: {
    title: 'Eating here?',
    back_to_table: 'Order to {{table}}. We’ll bring it to you.',
    scan_code: 'Scan the QR code on your table to order to it.',
  },
  notes: {
    table_unavailable: {
      title: 'This table’s QR code doesn’t work anymore.',
      text: 'Please ask the staff. You can still order for pickup.',
      text_no_pickup: 'Please ask the staff.',
    },
    table_ordering_off: {
      title: 'Ordering at the table isn’t available right now.',
      text: 'You can order for pickup instead.',
    },
    load_failed: {
      title: 'Couldn’t load your table.',
      text: 'Please scan the QR code again.',
    },
    closed: {
      title: 'Closed right now.',
      text: 'You can order at your table from {{time}}.',
      text_later: 'You can order at your table once we’re open again.',
    },
    paused: {
      title: 'Not taking orders right now.',
      text: 'Please ask the staff, or try again in a few minutes.',
    },
  },
  cart: {
    closed: 'Closed right now. You can order at your table from {{time}}. Your basket is kept until then.',
    closed_later: 'Closed right now. Your basket is kept until we’re open again.',
    paused: 'Not taking orders right now. Your basket is kept. Please ask the staff.',
  },
  cash_note: 'Pay in cash at the counter.',
  confirmation: {
    bring_to_table: 'We’ll bring your order to your table.',
    your_table: 'Your table',
    moved_table: 'Moved to another table? Tell the staff your order number <strong>{{number}}</strong>.',
  },
  served: 'Served',
};
